// pages/ForgotPassword/index.jsx
import React, { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const ForgotPassword = () => {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) { toast.warning('Informe seu e-mail'); return; }

    try {
      setLoading(true);
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Erro ao enviar. Tente novamente.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  // Tela de confirmação após envio
  if (sent) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div style={{ fontSize: '52px' }}>📧</div>
          <h5 className="mt-3 fw-bold">E-mail enviado!</h5>
          <p className="text-muted" style={{ fontSize: '14px', maxWidth: '320px' }}>
            Se este e-mail estiver cadastrado, você receberá
            as instruções em breve. Verifique sua caixa de entrada.
          </p>
          <Link to="/login" className="btn btn-outline-primary btn-sm mt-2">
            ← Voltar ao login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-sm p-4" style={{ width: '100%', maxWidth: '420px' }}>

        <h5 className="fw-bold mb-1 text-center">🔑 Esqueceu a senha?</h5>
        <p className="text-muted text-center mb-4" style={{ fontSize: '14px' }}>
          Informe seu e-mail e enviaremos um link para redefinir sua senha.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">E-mail</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seuemail@exemplo.com"
              autoFocus
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100" disabled={loading}>
            {loading
              ? <><Spinner size="sm" className="me-2" />Enviando...</>
              : '📨 Enviar link de recuperação'
            }
          </Button>

          <div className="text-center mt-3">
            <Link to="/login" style={{ fontSize: '13px' }} className="text-muted">
              ← Voltar ao login
            </Link>
          </div>
        </Form>

      </div>
    </div>
  );
};

export default ForgotPassword;
